<ul>
  @for (item of visibleItems; track item) {
    <li [ngClass]="{'is-active' : item.isActive}">
      <a [fragment]="item.id" [routerLink]="[]" href="">{{item.titre}}</a>
    </li>
  }
</ul>
